import logoImage from "../img/consultMidiaLogo.png";
import React from "react";
import FacebookPixel from "../capturePixel/Facebook";

export function ThankYouScreen() {

    return (
        <>
            <FacebookPixel nameTracking="Lead"/>
            <div>
                <div className=" d-block d-md-none">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
                <section>
                    <div className="thankYouDiv">
                        <span className="span">Muito obrigado, pelas informações!!!</span>
                        <br/>
                        <span>Em breve um especialista entrará em contato!!</span>
                    </div>
                </section>
            </div>
        </>
    );
}